import { render } from "./BadgesView.vue?vue&type=template&id=4cae2b51"
import script from "./BadgesView.vue?vue&type=script&lang=js"
export * from "./BadgesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__